module.exports = __webpack_public_path__ + "img/logo_getSoothing_01.e60dc788.svg";